import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom";
import { baseDate, zoomLevels } from "../utils/settings"
import SearchPopup from "./SearchPopup"
import { handleGoToDate } from "../utils/datePositionUtils"
import SesAyarlari from "./SesAyarlari"
import TarihGosterimi from "./TarihGosterimi"
import EventNavigationControls from "./EventNavigationControls"
import NavbarZoomControl from "./NavbarZoomControl"

const KullaniciNavbar = ({
	currentDate,
	onZoomChange,
	onScrollPositionChange,
	onEventSelect,
	interval,
	categories,
	filteredCategories = [],
	setFilteredCategories,
	timeFilter = { active: false },
	textFilter = { active: false },
	isAuthenticated,
	selectedEvent,
	onNext,
	onPrevious,
	isAutoPlaying,
	onAutoPlayToggle,
	onGoToFirst,
	onGoToLast,
	isReading,
	onReadingStateUpdate,
	timelineId,
	currentZoomIndex, // Accept from Timeline
	setCurrentZoomIndex, // Accept from Timeline
	hasMarkers = false,
	isOwner = false,
	onClearFilters,
}) => {
	const [showSearchPopup, setShowSearchPopup] = useState(false)
	const navigate = useNavigate();

	// REMOVED: const [currentZoomIndex, setCurrentZoomIndex] = useState(2);
	// REMOVED: useEffect for session storage zoom index - Timeline handles this now

	const [isLargeScreen, setIsLargeScreen] = useState(
		window.innerWidth >= 768 // Changed from 1024 to 768
	)

	useEffect(() => {
		const handleResize = () => {
			setIsLargeScreen(window.innerWidth >= 768) // Changed from 1024 to 768
		}

		window.addEventListener("resize", handleResize)
		return () => window.removeEventListener("resize", handleResize)
	}, [])

	// REMOVED: Component mount zoom initialization - Timeline handles this now

	// Initialize speech settings display values
	useEffect(() => {
		// Initialize volume value display
		const volumeElement = document.getElementById("volume-value")
		if (volumeElement) {
			volumeElement.textContent = "100%"
		}

		// Initialize rate value display
		const rateElement = document.getElementById("rate-value")
		if (rateElement) {
			rateElement.textContent = "1x"
		}
	}, [])



	const isAnyFilterActive =
		(filteredCategories && filteredCategories.length > 0) ||
		(timeFilter &&
			timeFilter.active &&
			(timeFilter.startYear !== null || timeFilter.endYear !== null)) ||
		(textFilter && textFilter.active && textFilter.text)

	const getActiveFilterCount = () => {
		let count = 0
		if (filteredCategories && filteredCategories.length > 0) count++
		if (
			timeFilter &&
			timeFilter.active &&
			(timeFilter.startYear !== null || timeFilter.endYear !== null)
		)
			count++
		if (textFilter && textFilter.active && textFilter.text) count++
		return count
	}

	// Function to trigger filter update notification
	const notifyFilterUpdate = () => {
		document.dispatchEvent(new CustomEvent("timelineFilterUpdated"))
	}

	// Add effect to monitor filter changes and update UI
	useEffect(() => {
		if (isAnyFilterActive) {
			notifyFilterUpdate()
		}
	}, [isAnyFilterActive, filteredCategories, timeFilter, textFilter])

	return (
		<>
			<nav className="hidden md:block fixed right-0 bg-gray-200 shadow-md z-40 h-10 left-[200px] top-10">
				<div className="flex items-center h-full">
					{/* Sol taraf - Kategoriler, Zoom ve Event Navigation */}
					<div className="flex items-center space-x-4 px-4">

						<NavbarZoomControl
							currentZoomIndex={currentZoomIndex}
							onZoomChange={onZoomChange}
						/>

						<TarihGosterimi
							currentDate={currentDate}
							onScrollPositionChange={onScrollPositionChange}
							interval={interval}
						/>

						{isLargeScreen && (
							<EventNavigationControls
								selectedEvent={selectedEvent}
								isReading={isReading}
								onPrevious={onPrevious}
								onGoToFirst={onGoToFirst}
								onGoToLast={onGoToLast}
								onNext={onNext}
								onAutoPlayToggle={onAutoPlayToggle}
								onReadingStateUpdate={onReadingStateUpdate}
								isAutoPlaying={isAutoPlaying}
							/>
						)}
					</div>

					{/* Sağ taraf - Arama ve Ses Ayarları */}
					<div className="flex items-center space-x-4 ml-auto px-4">
						{(isOwner || hasMarkers) && (
							<button
								onClick={() => navigate(`/cizelge/${timelineId}/harita`)}
								className="flex items-center justify-center space-x-2 text-gray-700 hover:bg-gray-300 rounded transition-colors py-1.5 px-3 gap-1"
								title="Tüm Haritalar"
							>
								<svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
									<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
								</svg>
							</button>
						)}

						{/* Clear filters button - only shows when filters are active */}
						{isAnyFilterActive && onClearFilters && (
							<button
								onClick={onClearFilters}
								className="flex items-center justify-center space-x-1 bg-red-100 text-red-700 hover:bg-red-200 rounded transition-colors py-1.5 px-3"
								title="Filtreleri Temizle"
							>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									className="h-4 w-4"
									fill="none"
									viewBox="0 0 24 24"
									stroke="currentColor"
								>
									<path
										strokeLinecap="round"
										strokeLinejoin="round"
										strokeWidth={2}
										d="M6 18L18 6M6 6l12 12"
									/>
								</svg>
								<span className="text-sm font-medium">
									Seçim ({getActiveFilterCount()})
								</span>
							</button>
						)}

						<button
							onClick={() => setShowSearchPopup(true)}
							className="flex items-center justify-center space-x-2 text-gray-700 hover:bg-gray-300 rounded transition-colors py-1.5 px-3 gap-1"
						>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								className="h-4 w-4"
								fill="none"
								viewBox="0 0 24 24"
								stroke="currentColor"
							>
								<path
									strokeLinecap="round"
									strokeLinejoin="round"
									strokeWidth={2}
									d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
								/>
							</svg>
							<span>Ara</span>
						</button>

						<SesAyarlari />
					</div>
				</div>
				{/* Sayfanın ortasına ortalanmış TarihGosterimi */}
				{/* <div className="fixed right-0 left-0 top-[70px] w-screen flex justify-center z-[999]">
				<TarihGosterimi
					currentDate={currentDate}
					onDateChange={(date) => {
						const newScrollPos = handleGoToDate(
							date,
							interval,
							baseDate
						)
						onScrollPositionChange(newScrollPos)
					}}
				/>
				</div> */}
			</nav>

			{showSearchPopup && (
				<SearchPopup
					onClose={() => setShowSearchPopup(false)}
					onEventSelect={onEventSelect}
					categories={categories}
					filteredCategories={filteredCategories}
					setFilteredCategories={setFilteredCategories}
					timeFilter={timeFilter}
					textFilter={textFilter}
					isOpen={showSearchPopup}
				/>
			)}
		</>
	)
}

export default KullaniciNavbar
